module.exports = __webpack_public_path__ + "img/1f498.e522a84.svg";